import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Programmazione', path: '/programmazione' },
    { name: 'Eventi e Rassegne', path: '/eventi-rassegne' },
    { name: 'Contatti', path: '/contatti' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-cinema-ivory/95 backdrop-blur-custom">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between w-full">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img 
              src="/images/CinemaItaliaLogo.svg" 
              alt="Cinema Italia" 
              className="h-6 md:h-8 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center justify-end flex-shrink-0">
            <nav className="flex items-center text-nav-spacing flex-nowrap">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`text-nav-menu text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors duration-300 font-medium flex-shrink-0 ${
                    location.pathname === item.path ? 'text-cinema-light-red' : ''
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="https://www.liveticket.it/cinemaitaliacastenaso"
                className="text-nav-menu bg-cinema-light-red text-white px-3 py-2 rounded-md font-normal hover:bg-cinema-red transition-colors duration-300 flex-shrink-0 ml-2"
              >
                <span className="hidden xl:inline">Acquista biglietti</span>
                <span className="xl:hidden">Biglietti</span>
              </Link>
            </nav>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-cinema-dark-charcoal focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-cinema-platinum pt-4">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`block py-2 text-cinema-dark-charcoal hover:text-cinema-light-red transition-colors duration-300 font-medium ${
                  location.pathname === item.path ? 'text-cinema-light-red' : ''
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="https://www.liveticket.it/cinemaitaliacastenaso"
              className="bg-cinema-light-red text-white px-4 py-2 rounded font-normal hover:bg-cinema-red transition-colors duration-300 block text-center mt-4"
              onClick={() => setIsMenuOpen(false)}
            >
              Acquista biglietti
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;